export default "/_next/static/media/enjoei-promobanner1-1024x307.f8e9ba7edb2e04336cacda90414fa9f1.png";